import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useMemo, useRef } from 'react';

import { notificationsAskAgain, type INotificationsAskAgain } from '../askAgain.js';

/**
 * The "ask again" of `notificationsAskAgain`, for the component that holds
 * the person's stream: one instance for the component's life, handed the
 * site as it is now — the stream outlives a site switch and reads the site
 * when a signal arrives — and dropping any ask still waiting when the
 * component goes.
 */
export function useNotificationsAskAgain(siteId: string | null): INotificationsAskAgain {
  const queryClient = useQueryClient();
  const siteRef = useRef(siteId);
  useEffect(() => {
    siteRef.current = siteId;
  }, [siteId]);

  const askAgain = useMemo(() => notificationsAskAgain(queryClient, () => siteRef.current), [queryClient]);
  useEffect(() => () => askAgain.dispose(), [askAgain]);
  return askAgain;
}
